import config from 'constants/config'

export default function getProviders(): Array<string> {
  const providerOverrides = config.FLIGHT_PROVIDER_OVERRIDE
  return providerOverrides ? providerOverrides.split(',') : []
}
